import { createSlice } from "@reduxjs/toolkit";
import {
  fetchItems,
  fetchItemById,
  updateItem,
  updateStatusInItem,
} from "./thunk";

interface ItemState {
  itemList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedItem: any;
}

const initialState: ItemState = {
  itemList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedItem: null,
};

const itemSlice = createSlice({
  name: "item",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchItems.fulfilled, (state, action) => {
        state.loading = false;
        state.itemList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch GPs";
      })
      .addCase(fetchItemById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchItemById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedItem = action.payload;
      })
      .addCase(fetchItemById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateItem.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.itemList = state.itemList.map((item) =>
          item.id === action.payload.id ? action.payload : item
        );
      })
      .addCase(updateItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInItem.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.itemList = state.itemList.map((item) =>
        //   item.id === action.payload.id ? action.payload : item
        // );
      })
      .addCase(updateStatusInItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default itemSlice.reducer;
